var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        persistent: "",
        "max-width": "900",
        scrollable: "",
        "hide-overlay": false,
        "content-class": "modal-impeditivo-ponto",
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _vm.loading
        ? _c(
            "v-card",
            [
              _c(
                "v-card-text",
                { staticClass: "text-center pa-8" },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", color: "primary", size: "64" },
                  }),
                  _c("p", { staticClass: "mt-4 text-body-1" }, [
                    _vm._v("Verificando pendências..."),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm.currentTerm
        ? _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "warning" } },
                [
                  _c("v-icon", { staticClass: "mr-2" }, [
                    _vm._v("mdi-alert-circle"),
                  ]),
                  _c("v-toolbar-title", [
                    _vm._v("Pendência de Termo Obrigatório"),
                  ]),
                  _c("v-spacer"),
                  _vm.pendingTerms.length > 1
                    ? _c(
                        "v-chip",
                        { staticClass: "mr-2", attrs: { small: "", dark: "" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.currentIndex + 1) +
                              " / " +
                              _vm._s(_vm.pendingTerms.length) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "ma-4 mb-0",
                      attrs: { type: "warning", dense: "", border: "left" },
                    },
                    [
                      _c("strong", [_vm._v("Atenção:")]),
                      _vm._v(
                        " Você possui termo(s) obrigatório(s) pendente(s) de assinatura. O acesso ao sistema permanece bloqueado até a assinatura. Assine abaixo para liberar imediatamente. "
                      ),
                    ]
                  ),
                  _c(
                    "v-card",
                    { staticClass: "ma-4", attrs: { flat: "" } },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "text-h6 pb-2" },
                        [
                          _c(
                            "v-icon",
                            { attrs: { left: "", color: "primary" } },
                            [_vm._v("mdi-file-document-outline")]
                          ),
                          _vm._v(" " + _vm._s(_vm.currentTerm.term.name) + " "),
                        ],
                        1
                      ),
                      _vm.currentTerm.term.description
                        ? _c("v-card-subtitle", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.currentTerm.term.description) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "div",
                    {
                      staticClass: "pa-4 term-content",
                      staticStyle: {
                        "max-height": "400px",
                        "overflow-y": "auto",
                      },
                    },
                    [
                      _vm.termContent
                        ? _c("div", {
                            domProps: { innerHTML: _vm._s(_vm.termContent) },
                          })
                        : _c("v-skeleton-loader", {
                            attrs: { type: "paragraph@3" },
                          }),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card",
                    { staticClass: "ma-4 grey lighten-4", attrs: { flat: "" } },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "text-subtitle-1 pb-2" },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: { left: "", color: "primary", small: "" },
                            },
                            [_vm._v("mdi-file-sign")]
                          ),
                          _vm._v(" Confirmação de Aceite "),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _vm.termOptions.length > 0
                            ? _c(
                                "v-radio-group",
                                {
                                  staticClass: "mt-0",
                                  attrs: { "hide-details": "" },
                                  on: { change: _vm.onOptionChange },
                                  model: {
                                    value: _vm.formOptionId,
                                    callback: function ($$v) {
                                      _vm.formOptionId = $$v
                                    },
                                    expression: "formOptionId",
                                  },
                                },
                                _vm._l(_vm.termOptions, function (opt) {
                                  return _c("v-radio", {
                                    key: opt.id,
                                    attrs: {
                                      label: opt.label,
                                      value: opt.id,
                                      color:
                                        opt.color ||
                                        (opt.is_valid_acceptance
                                          ? "success"
                                          : "grey"),
                                    },
                                  })
                                }),
                                1
                              )
                            : _vm.currentTerm.term.is_required
                            ? _c("v-checkbox", {
                                staticClass: "mt-0",
                                attrs: {
                                  label:
                                    _vm.currentTerm.term.label ||
                                    "Li e concordo com os termos acima",
                                  color: "primary",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.formAgree,
                                  callback: function ($$v) {
                                    _vm.formAgree = $$v
                                  },
                                  expression: "formAgree",
                                },
                              })
                            : _vm._e(),
                          _vm.showJustificationField
                            ? _c("v-textarea", {
                                staticClass: "mt-4",
                                attrs: {
                                  label: "Justificativa *",
                                  counter: 2000,
                                  rules: _vm.justificationRules,
                                  rows: "3",
                                  outlined: "",
                                  "persistent-placeholder": "",
                                  placeholder:
                                    "Informe o motivo da sua decisão...",
                                  hint: "A justificativa é obrigatória para a opção selecionada (mínimo 10 caracteres)",
                                  "persistent-hint": "",
                                },
                                model: {
                                  value: _vm.formJustification,
                                  callback: function ($$v) {
                                    _vm.formJustification = $$v
                                  },
                                  expression: "formJustification",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "pa-4" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        loading: _vm.submitting,
                        disabled: !_vm.canSubmit,
                        large: "",
                      },
                      on: { click: _vm.signTerm },
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-check"),
                      ]),
                      _c("span", [
                        _vm._v(" " + _vm._s(_vm.submitButtonLabel) + " "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("emc-alert-snackbar", {
        attrs: {
          show: !!_vm.message.length,
          message: _vm.message,
          color: _vm.error ? "error" : "success",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }